import { render, staticRenderFns } from "./card-rounded.vue?vue&type=template&id=039bb1ad&scoped=true&"
import script from "./card-rounded.vue?vue&type=script&lang=js&"
export * from "./card-rounded.vue?vue&type=script&lang=js&"
import style0 from "./card-rounded.vue?vue&type=style&index=0&id=039bb1ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039bb1ad",
  null
  
)

export default component.exports